module.exports = __webpack_public_path__ + "img/BJ.23eecb52.png";